import { fetchWrapper } from '~/utils/fetchWrapper'

interface ConnectorAnnotationOpKeyTask {
  pomDep: string
  opKey: string
  connector: string
  version: string
  configKey: string
}

interface ConnectorAnnotationSrcKeyTask {
  pomDep: string
  srcKey: string
  configKey: string
  connector: string
  version: string
}

export type ConnectorAnnotationTask = ConnectorAnnotationOpKeyTask | ConnectorAnnotationSrcKeyTask

interface ConnectorAnnotationTasks {
  tasks: ConnectorAnnotationTask[]
}

export const getAnnotationFields = async () => {
  const response = await fetchWrapper('/api/kb/annotation', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
  if (!response.ok) {
    const responseJson = await response.json()
    const reason = responseJson.detail
    throw new Error(`Failed to get annotation fields. ${reason}`)
  }
  return (await response.json()) as ConnectorAnnotationTasks
}

export interface ConnectorAnnotation {
  pom_dep: string
  action_type: 'source' | 'operation'
  config_code: string
  action_code: string
  action_description: string
}

export const saveAnnotationFields = async (annotation: ConnectorAnnotation) => {
  const response = await fetchWrapper('/api/kb/annotation', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(annotation)
  })
  if (!response.ok) {
    const responseJson = await response.json()
    const reason = responseJson.detail
    throw new Error(reason)
  }
  const { error } = await response.json()
  if (error) {
    throw new Error(error)
  }
}
